import React, { useState, useEffect } from "react";
// import clsx from "clsx";
import { useUpdateData } from "hooks/useApiHooks";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import { useGuide } from "contexts/v1/masterData/GuideContext";

const UpdateGuide = ({ initialData, refetch, onSuccess, onError }) => {
  const CREATE_URL = "/reservation";
  const { guides } = useGuide();
  console.log("UpdateGuide guides", guides.data);
  console.log("UpdateGuide initialData", initialData.data);

  // Konversi data guide menjadi opsi dropdown
  const guideOptions = guides?.data?.map((guide) => ({
    value: guide.id,
    label: guide.name,
  })) || [];

  // State untuk menyimpan form data
  const [formData, setFormData] = useState({
    guide_id: initialData?.guide || "", // Ambil nilai default dari initialData
  });

  // API untuk memperbarui guide
  const { updateData: updateProduct } = useUpdateData(
    `${CREATE_URL}/${initialData?.id}/guide`
  );

  // Gunakan hook untuk notifikasi
  const { handleSuccessToast, handleError } = useCanvasHandler();

  const handleGuideChange = async (e) => {
    const newGuideId = e.target.value;
  
    // Update state lokal
    setFormData((prev) => ({ ...prev, guide_id: newGuideId }));
  
    try {
      await updateProduct({ guide_id: newGuideId });
  
      handleSuccessToast("Guide updated successfully");
  
      if (typeof onSuccess === "function") {
        onSuccess();
      }
    } catch (error) {
      console.error("Error updating guide:", error);
      handleError("Failed to update guide.");
      if (typeof onError === "function") {
        onError();
      }
    }
  };
  

  // Tangani perubahan dropdown guide
  const handleGuideChangeVold = async (e) => {
    const newGuideId = e.target.value;

    // Update state lokal untuk mencerminkan guide yang baru
    setFormData((prev) => ({ ...prev, guide_id: newGuideId }));

    try {
      // Panggil API untuk update guide
      await updateProduct({ guide_id: newGuideId });

      // Tampilkan notifikasi sukses
      handleSuccessToast("Guide updated successfully");

      // Panggil callback sukses jika ada
      if (typeof onSuccess === "function") {
        onSuccess();
      }
    } catch (error) {
      console.error("Error updating guide:", error);

      // Tampilkan notifikasi error
      handleError("Failed to update guide.");

      // Panggil callback error jika ada
      if (typeof onError === "function") {
        onError();
      }
    }
  };

  // Sync initialData ketika berubah (misalnya setelah fetch data dari API)
  // useEffect(() => {
  //   if (initialData?.guide) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       guide_id: initialData.guide, // Pastikan sesuai dengan data yang diterima
  //     }));
  //   }
  // }, [initialData]);
  useEffect(() => {
    if (initialData?.guide_id) {
      setFormData((prev) => ({
        ...prev,
        guide_id: initialData.guide_id, // Ambil guide_id dari initialData
      }));
    }
  }, [initialData]);
  

  return (
    <form className="d-flex flex-column" style={{ height: "100%" }}>
      <div className="action-sheet-content flex-grow-1">
        {/* Input untuk guide */}
        <div className="form-group mb-3">
          <label htmlFor="guide" className="form-label">
            Guide
          </label>
          {/* <select
            className={clsx("form-select")}
            id="guide"
            name="guide"
            value={formData.guide_id} // Pastikan value dalam bentuk string (bukan object)
            onChange={handleGuideChange}
          >
            <option value="" disabled>
              Pilih guide
            </option>
            {guideOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select> */}
          <select
  className="form-select"
  id="guide"
  name="guide"
  value={formData.guide_id} // ✅ Pastikan ini adalah ID, bukan objek
  onChange={handleGuideChange}
>
  <option value="" disabled>
    Pilih guide
  </option>
  {guideOptions.map((option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  ))}
</select>

        </div>
      </div>
    </form>
  );
};

export default UpdateGuide;
